<main class="wedding-page">
  <div class="wedding-content">
    <header class="brand">
      <a routerLink="/" aria-label="D&D Twogether – főoldal">
        <img src="assets/logo-black.svg" alt="D&D Twogether – Flowers and more" width="260" />
      </a>
    </header>

    <section class="welcome" aria-labelledby="wedding-title">
      <p class="eyebrow">Esküvői virágdekoráció</p>
      <h1 id="wedding-title">Ti megálmodjátok.<br /><em>Mi virágba borítjuk.</em></h1>
      <p class="intro">Dia és Dóri vagyunk, a D&D Twogether megálmodói.
        A menyasszonyi csokortól a teljes helyszíndekorációig veletek álmodjuk meg a nagy nap virágait.</p>
      <a class="text-link" routerLink="/wedding" fragment="elso-csomag">Fedezzétek fel a csomagokat <span aria-hidden="true">↓</span></a>
    </section>

    <section id="csomagok" class="packages" aria-labelledby="packages-title">
      <div class="section-heading">
        <p class="eyebrow">Három csomag, személyre szabva</p>
        <h2 id="packages-title">A csokortól a teljes dekorációig.</h2>
      </div>
      <div class="package-grid">
        <article class="package" *ngFor="let package of packages; let i = index" [attr.id]="i === 0 ? 'elso-csomag' : null" [attr.aria-labelledby]="'package-' + i">
          <span class="package-number" aria-hidden="true">0{{ i + 1 }}</span>
          <p class="package-subtitle">{{ package.subtitle }}</p>
          <h3 [id]="'package-' + i">{{ package.name }}</h3>
          <p class="price">{{ package.price }} <span>Ft-tól</span></p>
          <ul><li *ngFor="let item of package.items">{{ item }}</li></ul>
          <a class="text-link" [href]="inquiryHref">Ajánlatot kérünk <span aria-hidden="true">↗</span></a>
        </article>
      </div>
      <div class="package-note">
        <p>A pontos tartalmat és mennyiségeket közösen igazítjuk hozzátok és az esküvőtökhöz.</p>
        <p class="fine-print">A csomagárakon felüli szervezési és logisztikai alapdíjat, valamint a helyszíni kivitelezés és bontás költségét a részletes, egyedi ajánlat tartalmazza.</p>
      </div>
    </section>

    <section class="contact" aria-labelledby="contact-title">
      <p class="eyebrow">Kezdjük egy beszélgetéssel</p>
      <h2 id="contact-title">Meséljetek az álomesküvőtökről!</h2>
      <p>Hozhattok kész elképzelést, néhány inspirációs képet vagy csak egy ötletet.</p>
      <a class="inquiry-button" [href]="inquiryHref">Személyre szabott ajánlatot kérünk <span aria-hidden="true">↗</span></a>
      <div class="contact-details">
        <a href="tel:+36300121051">+36-30/012-1051</a>
        <a [href]="'mailto:' + email">{{ email }}</a>
      </div>
      <a class="save-contact text-link" [href]="contactVcardUrl" download="twogether-flower.vcf">Elérhetőség mentése <span aria-hidden="true">↓</span></a>
      <address>1138 Budapest, Cserhalom utca – Mura utca sarka</address>
      <nav class="social-links" aria-label="Twogether Flowers elérhetőségek">
        <a *ngFor="let link of links" [href]="link.url" target="_blank" rel="noopener noreferrer">{{ link.label }}</a>
      </nav>
    </section>
    <footer>D&D Twogether <span aria-hidden="true">/</span> Flowers and more</footer>
  </div>
</main>
